import Utils from '@/ecm/common/Utils'
export default class ContentTypeFieldRight {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.roleTypeID = ''
        this.defFieldID = ''
        this.visible = true
        this.readonly = false
        this.conditionStr = ''
        this.displayConditionStr = ''

        if (dto) {
            this.id = dto.Id
            this.roleTypeID = dto.RoleTypeID + ''
            this.defFieldID = dto.DefFieldID + ''
            this.visible = dto.Visible
            this.readonly = dto.Readonly
            this.conditionStr = dto.ConditionStr
            this.displayConditionStr = dto.DisplayConditionStr
        }
    }

    toDto () {
        return {
            RoleTypeID: this.roleTypeID,
            DefFieldID: this.defFieldID,
            Visible: this.visible,
            Readonly: this.readonly,
            ConditionStr: this.conditionStr,
        }
    }
}
